import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/gogo/Header";
import { Hero } from "@/components/gogo/Hero";
import { Marquee } from "@/components/gogo/Marquee";
import { Services } from "@/components/gogo/Services";
import { Manifesto } from "@/components/gogo/Manifesto";
import { HowItWorks } from "@/components/gogo/HowItWorks";
import { Booking } from "@/components/gogo/Booking";
import { Pricing } from "@/components/gogo/Pricing";
import { About } from "@/components/gogo/About";
import { Reviews } from "@/components/gogo/Reviews";
import { FAQ } from "@/components/gogo/FAQ";
import { Contact } from "@/components/gogo/Contact";
import { WhatsAppFloat } from "@/components/gogo/WhatsAppFloat";
import AdminPage from "@/pages/Admin";
import AreaPage from "@/pages/AreaPage";

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <Manifesto />
      <HowItWorks />
      <Booking />
      <Pricing />
      <About />
      <Reviews />
      <FAQ />
      <Contact />
    </main>
    <WhatsAppFloat />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-obsidian min-h-screen">
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
